/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import ProgressionType from '@linc-technologies/linced-common/enums/progression-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import { service } from '@ember/service';

/**
 * edit enables being able to bulk change the recorded Levels / Expectations
 * Overview (LEO) progression judgements for a learner.
 */
export default class EditRoute extends Route {
  // Services
  @service
  options;

  @service
  store;

  model(params) {
    let goalSubjectId = params.subject_id;
    let store = this.store;
    let model = this.modelFor('people/person/progressions');

    let type = ProgressionType.PROGRESSION;

    model.subject = store.findRecord('goals/subject', goalSubjectId);
    model.expectations = store.query('milestones/expectation', {
      goalSubjectId,
    });
    model.levels = store.query('milestones/level', {
      goalSubjectId,
    });
    model.progressions = store.query('milestones/progression', {
      personId: model.person.id,
      goalSubjectId,
      latest: true,
      type,
    });
    model.changelog = store.query('milestones/progression', {
      personId: model.person.id,
      goalSubjectId,
      latest: false,
      type,
      limit: 50,
    });

    return hash(model);
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.reset();
  }
}
